import { useCallback } from "react"

export const useRequiredFormItem = (message = "${label} est requis") => {
    return useCallback((_message = message) => {
        return { rules: [{ required: true, message: _message }] }
    }, [message])
}